import pageHeader from './pageHeader.vue';
import modal from './modal.vue';

export default  {
    pageHeader,
    modal
};
